<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <div class="right-menu">
      <h3 class="title">ITSS会议周后台管理</h3>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" v-if="user">
        <div>
          <span>{{user.cuName}}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <span style="display:block;" @click="show = true">
            <el-dropdown-item>
              布局设置
            </el-dropdown-item>
          </span> -->
          <router-link to="/userCenter">
            <el-dropdown-item>
              个人中心
            </el-dropdown-item>
          </router-link>
          <span style="display:block;" @click="open">
            <el-dropdown-item divided>
              退出登录
            </el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
import Avatar from '@/assets/images/avatar.png'

export default {
  components: {
    Hamburger
  },
  data() {
    return {
      Avatar: Avatar,
      dialogVisible: false,
      user: null
    }
  },
  created() {
    this.user = localStorage.getItem('__fh_user') ? JSON.parse(localStorage.getItem('__fh_user')) : null
    console.log('用户信息+++', this.user)
  },
  computed: {
    ...mapGetters([
      'sidebar',
    ]),
    show: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    }
  },
  methods: {
    themeChange(val) {
      this.$store.dispatch('changeSetting', {
        key: 'theme',
        value: val
      })
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    open() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
      })
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 50px;
  height: 60px;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    line-height: 56px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
  .navbar-menu{
    padding: 0 10px;
    flex: 1;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .top-menu{
    flex: 1;
  }

  .right-menu {
    flex: 1;
    display: flex;
    justify-content: space-between;
    height: 100%;
    line-height: 60px;
    display: flex;
    align-items: center;
    padding-right: 30px;
    .title{
      flex: 1;
      font-size: 20px;
      color: #333;
      font-weight: bold;
      letter-spacing: 1px;
    }
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: flex;
      align-items: center;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>
